import { Box, Typography } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";

export const Info = ({ data }) => {
  return (
    <Box
      sx={{
        flex: 1,
        maxWidth: { xs: "100%", md: 420 },
        width: "100%",
        border: "1px solid var(--clr-primary)",
        px: { xs: 3, md: 4 },
        py: { xs: 4, md: 5 },
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      {/* Title */}
      <Typography
        sx={{
          fontFamily: "'Cormorant Garamond', serif",
          fontWeight: 500,
          fontSize: { xs: "1.2rem", md: "1.35rem" },
          letterSpacing: "0.08em",
          color: "var(--clr-primary)",
          mb: 1,
        }}
      >
        {data.title}
      </Typography>
      <Box
        sx={{
          width: 40,
          height: "1.5px",
          background:
            "linear-gradient(90deg, transparent, var(--clr-primary), transparent)",
          mb: 3,
        }}
      />

      {/* Phone */}
      <Typography
        sx={{
          fontFamily: "'Lato', sans-serif",
          fontWeight: 700,
          fontSize: "0.75rem",
          letterSpacing: "0.15em",
          textTransform: "uppercase",
          color: "var(--common-black)",
          mb: 0.5,
        }}
      >
        {data.phone.text}
      </Typography>
      <Typography
        sx={{ fontSize: "0.9rem", color: "#4a4a4a", mb: 0.3 }}
      >
        {data.phone.number}
      </Typography>
      {data.phone.disclaimer && (
        <Typography
          sx={{
            fontSize: "0.7rem",
            color: "var(--clr-primary)",
            mb: 2.5,
          }}
        >
          {data.phone.disclaimer}
        </Typography>
      )}

      {/* Email */}
      <Typography
        sx={{
          fontFamily: "'Lato', sans-serif",
          fontWeight: 700,
          fontSize: "0.75rem",
          letterSpacing: "0.15em",
          textTransform: "uppercase",
          color: "var(--common-black)",
          mb: 0.5,
        }}
      >
        {data.email.text}
      </Typography>
      <Typography sx={{ fontSize: "0.9rem", color: "#4a4a4a", mb: 2.5 }}>
        {data.email.name}
      </Typography>

      {/* Address */}
      <Typography
        sx={{
          fontFamily: "'Lato', sans-serif",
          fontWeight: 700,
          fontSize: "0.75rem",
          letterSpacing: "0.15em",
          textTransform: "uppercase",
          color: "var(--common-black)",
          mb: 0.5,
        }}
      >
        {data.address.text}
      </Typography>
      <Typography sx={{ fontSize: "0.85rem", color: "#4a4a4a", lineHeight: 1.7 }}>
        {data.address.name}
      </Typography>
      {data.address.nameSec && (
        <Typography
          sx={{ fontSize: "0.85rem", color: "#4a4a4a", lineHeight: 1.7, mb: 2.5 }}
        >
          {data.address.nameSec}
        </Typography>
      )}
      {!data.address.nameSec && <Box mb={2.5} />}

      {/* Social */}
      <Typography
        sx={{
          fontFamily: "'Lato', sans-serif",
          fontWeight: 700,
          fontSize: "0.75rem",
          letterSpacing: "0.15em",
          textTransform: "uppercase",
          color: "var(--common-black)",
          mb: 1,
        }}
      >
        {data.social.text}
      </Typography>
      <Box display="flex" gap={2} justifyContent="center">
        {data.social.content.map((soc, id) => (
          <Link
            key={id}
            to={soc.link}
            target="_blank"
            style={{ textDecoration: "none" }}
          >
            <Typography
              sx={{
                fontSize: "0.85rem",
                color: "var(--clr-primary)",
                borderBottom: "1px solid transparent",
                transition: "border-color 0.3s ease",
                "&:hover": {
                  borderBottom: "1px solid var(--clr-primary)",
                },
              }}
            >
              {soc.type}
            </Typography>
          </Link>
        ))}
      </Box>
    </Box>
  );
};
